import { useCallback } from 'react';
import math from '../utils/math';
import { culTaxAndServiceFee, getProductLineAmount, shouldShowPackageDiscount } from '../utils/price';

// 产品相关计算逻辑
const useProductCalculations = (products, pdRemarkMap, productInfo, storeInfo) => {
    const getProductAmount = useCallback((item) => {
        return getProductLineAmount(item) || 0;
    }, []);

    const getGroupName = (key, attrs = []) => {
        const obj = attrs.find(item => item.attrKey === key)
        if (obj) {
            return obj.attrName || ''
        }
        return ''
    }

    const getProductList = useCallback(() => {
        const productList = products.length > 0 ? products : [productInfo];
        return productList.map((item, index) => {
            const { productId, productName,
                price, packagePrice, orgPrice, quantity, images,
                currency, currencyCode, attrArr,
                specItem, fromRec = false,
                attrs, isSmartRecommend = false, productType } = item;
            const totalPrice = getProductAmount(item);
            const remark = pdRemarkMap[`${productId}-${index}`] || '';
            //是否有分组情况
            const hasGroupKey = item.attrs?.some(attr => attr.groupKey)

            let taxFeeObj = null;
            if(productType && productType.serviceFeeType  && productType.taxType){
                if(productType.serviceFeeType || productType.taxType){
                    taxFeeObj = getProductTaxAndServiceFee(item, totalPrice);
                }else{
                    taxFeeObj = culTaxAndServiceFee(totalPrice,storeInfo,totalPrice);
                }
            }else{
                // taxFeeObj = culTaxAndServiceFee(totalPrice,storeInfo,totalPrice);
            }
            // const taxFeeObj = (productType && (productType.serviceFeeType || productType.taxType)) ? getProductTaxAndServiceFee(item, totalPrice) : null
            

            return {
                amount: quantity || item.quantity || 1,
                isPackage: false,
                productId,
                productName: productName || item.name,
                productTypeName: '',
                productExtraNameKey: specItem?.productExtraNameKey || '',
                productExtraAttrSubKeyValues: attrArr?.map(attr => ({
                    key: attr.productExtraAttrSubKey,
                    name: attr.productExtraAttrSubName,
                    num: attr.quantity || 1,
                    groupKey: attr.groupKey,
                    groupName: getGroupName(attr.productExtraAttrKey, attrs),
                    parentKey: hasGroupKey ? attr.productExtraAttrKey : '',
                })) || [],
                price,
                packagePrice,
                orgPrice: shouldShowPackageDiscount(item) ? price : orgPrice,
                images,
                currency: currency || currencyCode,
                attrArr,
                specItem,
                productAmount: taxFeeObj ? taxFeeObj.totalPrice : totalPrice,
                priceType: item.priceType,
                remark,
                fromRec,
                specsKey: item.specsKey,
                attrKeys: item.attrKeys,
                subAttrKeys: item.subAttrKeys,
                recommendProduct: !!fromRec,
                isSmartRecommend,
                taxAndServiceFee: taxFeeObj
            };
        });
    }, [products, pdRemarkMap, getProductAmount, productInfo]);

    const getProductTotalMoney = useCallback(() => {
        const productArr = getProductList();

        const productNetPrice = productArr.reduce((acc, item) => {
            if(item.taxAndServiceFee) {
                return math.add(acc, math.mul(getProductAmount(item), item.amount))
            }
            
            return math.add(acc, 0)
        }, 0);
        const productTotalAmount = productArr.reduce((acc, item) => {
            return math.add(acc, math.mul(item.productAmount || 0, item.amount))
        }, 0);

        const normalTotal =  productArr.reduce((acc, item) => {
            if (item.taxAndServiceFee) {
                return math.add(acc, 0)
            }
            return math.add(acc, math.mul(item.productAmount || 0, item.amount))

        }, 0);

        const totalIncludeFee = productArr.reduce((acc, item) => {
            if (item.taxAndServiceFee) {
                return math.add(acc, math.mul(item.productAmount || 0, item.amount))
            }
            return math.add(acc, 0)
        }, 0);
        
        return {
            normalTotal,
            totalIncludeFee,
            productTotalAmount,
            productNetPrice
        }
        
    }, [getProductList, getProductAmount]);

    const getProductTaxAndServiceFee = useCallback((product, totalPrice) => {
        const { productType } = product
        const obj = culTaxAndServiceFee(totalPrice, {
            serviceFeeType: productType.serviceFeeType,
            serviceFeeRate: productType.serviceRate,
            taxType: productType.taxType,
            taxRate: productType.taxRate
        }, totalPrice)
        console.log(obj)
        return obj
    }, []);

    return { getProductList, getProductTotalMoney, getProductAmount };
};

export default useProductCalculations;
